import { connect } from 'react-redux'
import { getApper, postQingjiaEditor } from './actions'
import Setting from './main'


const mapDispatchToProps = {
  getApper,
  postQingjiaEditor
}
const mapStateToProps = (state) => {
  return {
    ...state.QingjiaEditor
  }
}
  

export default connect(mapStateToProps, mapDispatchToProps)(Setting)
